const ON_QI_INIT = "ON_QI_INIT";
const ON_QI_MESSAGE = "ON_QI_MESSAGE";

export const rdx_on_qi_init = (newState) => ({ type : ON_QI_INIT, newState })
export const rdx_on_qi_message = (newState) => ({ type : ON_QI_MESSAGE, newState })

export const qi = (state = {}, action) => {
	switch (action.type) {
    	case ON_QI_INIT :

	      	return { ...state, session : action.newState }

	    case ON_QI_MESSAGE :

	      	return { ...state, message : action.newState }

    	default: return state;
  	}
}


// WEBPACK FOOTER //
// ./src/reducers/qi.js